import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description CCFast icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { CCFast } from '@sravni/design-system-icons'
 *
 * <CCFast />
 * ```
 */
var CCFast = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "CCFast", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m13.22 13.333 4.528-4.528c.651-.65.651-1.706 0-2.357l-2.626-2.626a1.666 1.666 0 0 0-2.356 0L7.648 8.94c-.65.65-.65 1.706 0 2.357l2.037 2.036M17.403 16.667H4.07a.834.834 0 0 1-.834-.834v-1.666c0-.46.374-.834.834-.834h13.333c.46 0 .833.374.833.834v1.666c0 .46-.373.834-.833.834ZM3.236 3.333h4.167M3.236 5.833h2.5M3.236 8.333h.834M8.336 11.983l7.475-7.475", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { CCFast };
//# sourceMappingURL=CCFast.js.map
